(function () {
    'use strict';

    angular
        .module('webinar')
        .controller('WebinarRequestEditController', WebinarRequestEditController);

    WebinarRequestEditController.$inject = ['$uibModalInstance','webinarResponse','webinarItem','WebinarService','Upload','API_BASE'];

    function WebinarRequestEditController($uibModalInstance,webinarResponse, webinarItem, WebinarService, Upload, API_BASE) {
        var vm = this;

        vm.webinarItem      = webinarItem;
        vm.webinarResponse  = webinarResponse;
        vm.ok               = ok;
        vm.cancel           = cancel;
        vm.checkAll         = checkAll;
        vm.update           = update;
        vm.doUpload         = doUpload;
        vm.deletePhoto      = deletePhoto;
        vm.updateRepresentativePicture = updateRepresentativePicture;
        vm.representativePicture = false;
        vm.checkedLocation  = {};
        vm.timezone         = '';
        vm.date             = '';
        vm.photos           = {};
        vm.hours            = [
            {id: 1, name: '1 hour'},
            {id: 2, name: '2 hours'},
            {id: 3, name: '3 hours'},
            {id: 4, name: '4 hours'},
            {id: 5, name: '5 hours'},
            {id: 6, name: '6 hours'},
            {id: 7, name: '7 hours'},
            {id: 8, name: '8 hours'},
            {id: 9, name: '9 hours'},
            {id: 10, name: '10 hours'}
            ];
        vm.duration         = vm.hours[webinarItem.webinar.duration];
        vm.sellerSelected   = '';

        //vm.update          = update;

        //FormData
        vm.formData         = [];

        angular.copy(webinarItem,vm.formData);

        activate();

        function activate() {
            angular.forEach(vm.formData.webinar.locations[vm.formData.webinar.target.id], function(value) {
                vm.checkedLocation[value.id] = true;
                console.log(vm.checkedLocation[value.id]);
            });
            if(vm.formData.webinar.seller > 0)
            {
                vm.sellerSelected = webinarResponse.sellers[vm.formData.webinar.seller];
            }
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function checkAll(location)
        {
            if(vm.checkedLocation[location.id] === true){
                if(!vm.formData.webinar.locations[vm.formData.webinar.target.id])
                {
                    vm.formData.webinar.locations = {};
                    vm.formData.webinar.locations[vm.formData.webinar.target.id] = {};
                    vm.formData.webinar.locations[vm.formData.webinar.target.id][location.id] = location;
                }
                vm.formData.webinar.locations[vm.formData.webinar.target.id][location.id] = location;
                if(location.type == 'all'){
                    angular.forEach(vm.webinarResponse.webinar_locations[vm.formData.webinar.target.id].locations, function (location, index) {
                        if (location.checked_for_all) {
                            vm.formData.webinar.locations[vm.formData.webinar.target.id][index] = location;
                        }
                    });
                }
            }
            else{
                delete(vm.formData.webinar.locations[vm.formData.webinar.target.id][location.id]);
            }
        }

        function update() {
            doUpload();
            updateRepresentativePicture();
            vm.query = {};
            vm.query['id']                          = vm.formData.webinar.id;
            vm.query['locations']                   = vm.formData.webinar.locations[vm.formData.webinar.target.id];
            vm.query['target']                      = vm.formData.webinar.target.id;
            vm.query['title']                       = vm.formData.webinar.title;
            vm.query['description']                 = vm.formData.webinar.description;
            vm.query['representative_name']         = vm.formData.webinar.representative_name;
            vm.query['representative_title']        = vm.formData.webinar.representative_title;
            vm.query['representative_email']        = vm.formData.webinar.representative_email;
            vm.query['website']                     = vm.formData.webinar.website;
            vm.query['time_your_city']              = vm.formData.webinar.time_your_city;
            vm.query['language']                    = vm.formData.webinar.language.id;
            vm.query['presentation_date']           = convertToUTC(new Date(vm.formData.webinar.presentation_date));
            vm.query['duration']                    = vm.formData.webinar.duration;
            vm.query['timezone']                    = vm.formData.webinar.timezone;
            vm.query['external_webinar_id']         = vm.formData.webinar.external_webinar_id;
            vm.query['video_url']                   = vm.formData.webinar.video_url;
            vm.query['seller']                      = 5;

            WebinarService.update(vm.query).then(function(response){
                ok();
                alertify.success('Webinar successfully updated');
                webinarItem.webinar.target = response.data.target;
                webinarItem.webinar.title  = response.data.title;
                webinarItem.webinar.description  = response.data.description;
                webinarItem.webinar.representative_name  = response.data.representative_name;
                webinarItem.webinar.representative_title  = response.data.representative_title;
                webinarItem.webinar.representative_email  = response.data.representative_email;
                webinarItem.webinar.website  = response.data.website;
                webinarItem.webinar.time_your_city  = response.data.time_your_city;
                webinarItem.webinar.language  = webinarResponse.languages[response.data.language];
                webinarItem.webinar.presentation_date_utc  = response.data.presentation_date_utc;
                webinarItem.webinar.duration  = response.data.duration;
                webinarItem.webinar.timezone  = response.data.timezone;
                webinarItem.webinar.external_webinar_id  = response.data.external_webinar_id;
                webinarItem.webinar.video_url  = response.data.video_url;
                webinarItem.webinar.seller  = webinarResponse.sellers[response.data.seller_id];
                webinarItem.webinar.locations[response.data.target.id]  = response.data.locations;
                vm.sellerSelected = webinarResponse.sellers[response.data.seller_id];
                vm.checkedLocation = {};
                angular.forEach(response.data.locations, function(value) {
                    vm.checkedLocation[value.id] = true;
                });
                //angular.copy(webinarItem,vm.formData);
            }).catch(function(err) {
                alertify.error(err);
            });
        }

        function convertToUTC(date)
        {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        }

        function deletePhoto(photo)
        {
            vm.query = {};
            vm.query['photo'] = photo;
            WebinarService.deletePhoto(vm.query).then(function(response){
                angular.forEach(vm.formData.photos, function(value, key) {
                    if(value.webinar_id==photo.webinar_id && value.photo_name == photo.photo_name)
                    {
                        vm.formData.photos.splice(key, 1);
                        alertify.success("Photo successfully deleted!");
                    }
                });
            }).catch(function(err) {
                alertify.error(err);
            });
        }

        function updateRepresentativePicture()
        {
            if (vm.representativePicture) {
                Upload.upload({
                    url: API_BASE + '/webinar/representativePicture',
                    data: {file: vm.representativePicture, webinar : vm.webinarItem}
                }).then(function (resp) {
                    console.log(webinarItem);
                    webinarItem.webinar.representative_picture_url = resp.data;
                    vm.formData.webinar.representative_picture_url = resp.data;
                    alertify.success("Representative picture successfully updated!");
                }, function (resp) {
                    console.log('Error status: ' + resp.status);
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                });
            }
        }

        function doUpload() {
            // for multiple files:
            if (vm.photos && vm.photos.length) {
                for (var i = 0; i < vm.photos.length; i++) {
                    Upload.upload({
                        url: API_BASE + '/webinar/photos',
                        data: {file: vm.photos[i], webinar : vm.webinarItem}
                    }).then(function (resp) {
                        vm.webinarItem.photos.push({
                            url : resp.data.url,
                            user_id : resp.data.user_id,
                            photo_name : resp.data.photo,
                            webinar_id : resp.data.webinar_id
                        });
                    }, function (resp) {
                        console.log('Error status: ' + resp.status);
                    }, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    });
                }
            }
        };

    }

})();